import { serviceAriToServiceUrlParam } from '@atlassian/jira-servicedesk-services-core/src/utils.tsx';

// when changing the URLs here, make sure to update the URLs generated for the issue view too!
export const getServiceRegistryUrl = (projectKey?: string): string => {
	// Allows showing services page in a top nav outside of project context
	if (!projectKey) {
		return '/jira/servicedesk/services';
	}

	return `/jira/servicedesk/projects/${projectKey}/services`;
};

export const getServiceDetailsUrl = (projectKey: string | undefined, serviceId: string) =>
	`${getServiceRegistryUrl(projectKey)}/${serviceAriToServiceUrlParam(serviceId)}`;

export const getServiceDetailsCompassUrl = (serviceId: string) => {
	const splittedServiceId = serviceId.split('/') || [];
	const compassServiceId =
		splittedServiceId.length > 0
			? splittedServiceId[splittedServiceId.length - 1]
			: splittedServiceId[0];
	return `https://hello.atlassian.net/compass/component/${compassServiceId}`;
};
